module.exports = __webpack_public_path__ + "img/copy-pay-card.11fdd13a.png";